module.exports = __webpack_public_path__ + "static/media/CC_NG_LP_animation_BG.ffb40356.gif";